/**
 * Класс для управления динамическим полем select в приложении
 * @package DynamicFieldClass
 * @version 1.0
 * @author BOLOTOV I.P.
 * @since 17.08.2022
 * @copyright (c) Internet-Frigate {@link http://www.ifrigate.ru}
 */
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, OnInit } from '@angular/core';
import { InterfaceAppServiceRegister } from '@app/app.interface';
import { AppService } from '@app/app.service';
import { FuiDestroyService } from '@services/destroy.service';
import { take, takeUntil } from 'rxjs/operators';
import { ISelect } from '../interfaces/Select.interface';
import { SelectSearch } from './SelectSearch.class';
import { SelectServiceLib } from './SelectServiceLib.service';

@Injectable()
export abstract class SelectSearchLoad extends SelectSearch implements ISelect, OnInit {
    /** Constructor */
    protected constructor(
        @Inject(FuiDestroyService) protected _destroy$: FuiDestroyService,
        public service: SelectServiceLib,
        public http: HttpClient,
        public appService: AppService,
    ) {
        super(_destroy$, service);
    }

    /**
     * Установка опций select
     * @param options - набор опций
     */
    setOptions(options: InterfaceAppServiceRegister[]): void {
        this.service.isShowSpinner.next(true);
        if (Array.isArray(options)) {
            super.setOptions(options);
            this.service.isShowSpinner.next(false);
            return;
        }

        if (!this.service.field.hasOwnProperty('getData') || !this.service.field.getData) {
            // Оставляем висящим прелоадер
            return;
        }

        this.service.field.getData.pipe(takeUntil(this._destroy$)).subscribe((result) => {
            const list: InterfaceAppServiceRegister[] = result as InterfaceAppServiceRegister[];
            this.service.options = list;
            super.setOptions(list);
            setTimeout(() => {
                this.service.isShowSpinner.next(false);
            });
            // Событие, которое вызовет изменение опций select
            if (this.service.field?.getChanges) {
                this.setChanges();
            }
        });
    }

    ngOnInit(): void {
        super.ngOnInit();
    }

    /** Изменение опций select */
    setChanges(): void {
        this.service.field.getChanges.pipe(takeUntil(this._destroy$)).subscribe((value) => {
            this.service.isShowSpinner.next(true);
            value.pipe(take(1), takeUntil(this._destroy$)).subscribe((result) => {
                this.service.options = result;
                super.setOptions(this.service.options.slice());
                this.service.group.get(this.service.field.name).reset();
                this.service.isShowSpinner.next(false);
            });
        });
    }
}
